<template>
  <!-- role="group" : l'appelant le nomme, par aria-labelledby (FieldControl,
       BlueSectionLogistique) ou par aria-label (BesoinCommunSection). -->
  <div role="group">
    <div class="checkbox-group-options">
      <Checkbox
        v-for="opt in options"
        :key="opt.value"
        :model-value="modelValue?.includes(opt.value)"
        :label-text="opt.label"
        :disabled="disabled"
        no-wrapper
        @update:model-value="toggleValue(opt.value)"
      />
    </div>
    <div v-if="autreField && modelValue?.includes('autre')" class="q-field q-mt-8">
      <textarea
        :value="autreValue"
        rows="2"
        placeholder="Précisez…"
        aria-label="Précisez"
        :disabled="disabled"
        @input="$emit('update:autreValue', $event.target.value)"
      />
    </div>
  </div>
</template>

<script setup>
import { Checkbox } from '../ui'

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
  autreField: {
    type: Boolean,
    default: false,
  },
  autreValue: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'update:autreValue'])

function toggleValue(value) {
  const current = props.modelValue || []
  const updated = current.includes(value)
    ? current.filter(v => v !== value)
    : [...current, value]
  emit('update:modelValue', updated)
}
</script>

<style scoped>
.checkbox-group-options {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}
</style>
